// extracted by mini-css-extract-plugin
export default {"Content":"Writeup_Content__U-LEL","ContentCode":"Writeup_ContentCode__HHZMI"};